import React from "react";

const CONFIG = {
  ACTIVE:              { cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20", label: "Aktiv" },
  PENDING:             { cls: "bg-amber-500/10 text-amber-400 border-amber-500/20", label: "Pågår" },
  WAITING_INFORMATION: { cls: "bg-blue-500/10 text-blue-400 border-blue-500/20", label: "Venter info" },
  CLOSED:              { cls: "bg-zinc-800/60 text-zinc-400 border-zinc-700", label: "Avsluttet" },
  INACTIVE:            { cls: "bg-zinc-800/60 text-zinc-400 border-zinc-700", label: "Inaktiv" },
  BLOCKED:             { cls: "bg-red-500/10 text-red-400 border-red-500/20", label: "Sperret" },
  RESTORED:            { cls: "bg-violet-500/10 text-violet-400 border-violet-500/20", label: "Gjenopprettet" },
  aktiv:         { cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20", label: "Aktiv" },
  inaktiv:       { cls: "bg-zinc-800/60 text-zinc-400 border-zinc-700", label: "Inaktiv" },
  sperret:       { cls: "bg-red-500/10 text-red-400 border-red-500/20", label: "Sperret" },
  utkast:        { cls: "bg-zinc-800/60 text-zinc-400 border-zinc-700", label: "Utkast" },
  sendt:         { cls: "bg-blue-500/10 text-blue-400 border-blue-500/20", label: "Sendt" },
  betalt:        { cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20", label: "Betalt" },
  delvis_betalt: { cls: "bg-amber-500/10 text-amber-400 border-amber-500/20", label: "Delvis betalt" },
  purret:        { cls: "bg-orange-500/10 text-orange-400 border-orange-500/20", label: "Purret" },
  inkasso:       { cls: "bg-red-500/10 text-red-400 border-red-500/20", label: "Inkasso" },
  kreditert:     { cls: "bg-zinc-800/60 text-zinc-400 border-zinc-700", label: "Kreditert" },
  ny:            { cls: "bg-blue-500/10 text-blue-400 border-blue-500/20", label: "Ny" },
  under_arbeid:  { cls: "bg-amber-500/10 text-amber-400 border-amber-500/20", label: "Under arbeid" },
  venter_kunde:  { cls: "bg-violet-500/10 text-violet-400 border-violet-500/20", label: "Venter" },
  lost:          { cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20", label: "Løst" },
  lukket:        { cls: "bg-zinc-800/60 text-zinc-400 border-zinc-700", label: "Lukket" },
  lav:           { cls: "bg-zinc-800/60 text-zinc-400 border-zinc-700", label: "Lav" },
  normal:        { cls: "bg-blue-500/10 text-blue-400 border-blue-500/20", label: "Normal" },
  hoy:           { cls: "bg-orange-500/10 text-orange-400 border-orange-500/20", label: "Høy" },
  kritisk:       { cls: "bg-red-500/10 text-red-400 border-red-500/20", label: "Kritisk" },
  innflytting:   { cls: "bg-blue-500/10 text-blue-400 border-blue-500/20", label: "Innflytting" },
  utflytting:    { cls: "bg-amber-500/10 text-amber-400 border-amber-500/20", label: "Utflytting" },
  avsluttet:     { cls: "bg-zinc-800/60 text-zinc-400 border-zinc-700", label: "Avsluttet" },
  oppsagt:       { cls: "bg-red-500/10 text-red-400 border-red-500/20", label: "Oppsagt" },
};

export default function StatusBadge({ value, label, testid }) {
  const c = CONFIG[value] || { cls: "bg-zinc-800/60 text-zinc-400 border-zinc-700", label: label || value };
  return (
    <span
      className={`inline-flex items-center border rounded-full px-2 py-0.5 text-[11px] font-medium ${c.cls}`}
      data-testid={testid || `status-${value}`}
    >
      {label || c.label}
    </span>
  );
}
